import React, { useContext } from "react";
import "./styles/Blog.css";
import "./secundarios/EntradaBlog";
import EntradaBlog from "./secundarios/EntradaBlog";
import ScrollToTopOnMount from "../utilities/ScrollToTopOnMount";
import BlogContext from "../../Context/BlogContext";
const Blog = () => {
  const { posts } = useContext(BlogContext);

  console.log(posts);
  return (
    <>
      <ScrollToTopOnMount />

      <div className="c-blog">
        <h1 className="title-1 blog-title">Ultimas entradas</h1>
        <div className="blog-entradas">
          {posts.map((post) => (
            <EntradaBlog data={post} />
          ))}
        </div>
      </div>
    </>
  );
};

export default Blog;
